<div>
  <div *ngIf="showHeader">
    <div class="text-lg text-black font-bold mb-7">
      {{ pages[pageName] ?? 'Phone number' }}
    </div>
  </div>

  <div
    [ngClass]="{
      '!px-0 ': !showHeader
    }"
  >
    <form
      [formGroup]="phoneNumbersForm"
      class="profile-content-layout"
      [class.disabled]="sameAsCompany"
    >
      <ng-template [ngIf]="phonesFormArray?.controls?.length ?? 0 > 0">
        <div
          class="flex flex-col sm:flex-row sm:items-center gap-0 sm:gap-3 mb-4"
          formArrayName="phones"
          *ngFor="let group of phonesFormArray.controls; let i = index"
        >
          <div class="flex-1">
            <mat-form-field
              [formGroupName]="i"
              class="inline-input-select w-full"
            >
              <mat-label>{{ pages[pageName] ?? 'Phone number' }}</mat-label>
              <input
                [textMask]="PHONE_NUMBER_INPUT_MASK_CONFIG"
                matInput
                type="text"
                formControlName="phoneNumber"
                [readonly]="keepDisableSaveBtn"
              />
              <mat-select
                formControlName="phoneType"
                [disabled]="keepDisableSaveBtn"
                [(ngModel)]="phoneTypes[0].name"
              >
                <mat-option
                  *ngFor="let phoneType of phoneTypes"
                  [value]="phoneType.name"
                  >{{ phoneType.name }}</mat-option
                >
              </mat-select>
              <mat-error>{{ pages[pageName] }} is required</mat-error>
            </mat-form-field>
          </div>
          <div class="flex gap-2 w-full sm:w-auto sm:flex-shrink-0">
            <button
              [disabled]="!canDelete"
              (click)="confirmDelete(group, i)"
              tix-button
              color="light"
              class="bg-transparent flex-1 sm:flex-none"
            >
              <tix-icon svgIcon="trash"></tix-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </form>
    <button
      class="flex items-center space-x-1 text-primary text-xs"
      [disabled]="!canAdd"
      (click)="addNewPhoneHandler()"
      *ngIf="!sameAsCompany"
    >
      <span class="material-icons">add</span>
      <span class="text-sm hover:underline"> Add another</span>
    </button>
    <!-- <pre> {{ phoneNumbersForm.value | json }} </pre> -->
  </div>

  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-3">
    <div
      *ngIf="sameAsCompany !== undefined"
      class="flex-1 sm:flex-none self-center"
    >
      <tix-checkbox
        [disabled]="!canEdit"
        [checked]="sameAsCompany!"
        (change)="checkSameAsCompany($event)"
        [labelPosition]="'before'"
      >
        Is the Phone Numbers the same as the Company Phone Numbers?
      </tix-checkbox>
    </div>

    <div
      class="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:ml-auto justify-end"
    >
      <button
        mat-stroked-button
        class="w-full sm:w-auto px-6 py-1.5 sm:py-1 text-sm font-medium border border-primary text-primary hover:bg-primary-50 order-2 sm:order-1"
        *ngIf="showSkipButton"
        (click)="skipThisCard()"
      >
        Skip
      </button>

      <button
        mat-button
        *ngIf="canEdit"
        (click)="handleSaveClick()"
        class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium order-1 sm:order-2"
        [ngClass]="[
          keepDisableSaveBtn ||
          !phoneNumbersForm.valid ||
          phoneNumbersForm.pristine ||
          isloading
            ? 'cursor-not-allowed'
            : 'cursor-pointer',
          keepDisableSaveBtn ||
          !phoneNumbersForm.valid ||
          (phoneNumbersForm.pristine && !isloading)
            ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
            : 'hover:bg-primary-700'
        ]"
        [disabled]="
          keepDisableSaveBtn ||
          !phoneNumbersForm.valid ||
          phoneNumbersForm.pristine ||
          isloading
        "
      >
        <div *ngIf="!isloading" class="flex items-center justify-center">
          <span class="material-icons-outlined mr-2 text-lg">save</span>
          <span>Save Changes</span>
        </div>
        <div
          *ngIf="isloading"
          class="flex items-center justify-center space-x-2"
        >
          <span class="mr-2" *tixBtnLoading="isloading"></span>
          <span>Loading</span>
        </div>
      </button>
    </div>
  </div>
</div>
